import { render } from "./ReleasesPage.vue?vue&type=template&id=31ce3aee"
import script from "./ReleasesPage.vue?vue&type=script&lang=js"
export * from "./ReleasesPage.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__